import React, {useCallback} from 'react'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {CFValue} from 'module/CustomField/type/CFType'
import {useDqSearchRx} from 'module/Slct/impl/hook/useDqSearchRx'
import {useMemoParams} from 'module/Memo/hook/useMemoDq'
import {SlctLabelOnly} from 'module/Slct/component/SlctLabelOnly'
import {SlctOnChangeState, SlctOption} from 'module/Slct/type/SlctType'
import {filterOptionsSlctNoValue} from 'module/Slct/util/filterOptionsSlct'
import {cssCFSlct} from 'module/CustomField/style/cssCFInput'
import {SetCb} from 'type/SetCb'
import {useSlctCFAttrs} from 'module/Slct/hook/useSlctCFAttrs'
import {isDqSearchable} from 'module/Dq/util/DqParser'
import {getCFAttrTextAlign} from 'module/CustomField/style/CFAlignmentStyle'

export const CustomFieldDqLabelComponent = React.memo(function CustomFieldDqLabelComponent<ModelType extends object | void, ValueType extends string | number>(props: CFComponentProps<CFValue>) {
	const {
		cfDef,
		pos,
		setCb,
		setAzeText,
		model,
		modelValue,
		disabled,
		placeholderHTML,
	} = props

	const {
		searchSubject,
		suggestions,
		byValueCache,
		loading,
	} = useDqSearchRx(props)
	const options = suggestions as SlctOption<ModelType, ValueType>[]
	const memoParams = useMemoParams(cfDef)
	const {menuWidth} = useSlctCFAttrs(cfDef)

	const onChangeState = useCallback<SlctOnChangeState>(({focus, inputValue}) => {
		if (focus) {
			searchSubject.next({searchTerm: inputValue, model})
		} else {
			searchSubject.next({searchTerm: '', model})
		}
	}, [searchSubject, model])

	const onChange: SetCb<SlctOption<ModelType, ValueType> | null> = useCallback((x) => {
		setCb(x?.value)
		if (x?.azetext && setAzeText) {
			setAzeText({bookingNr: model.bookingNr, azetext: x.azetext})
		}
	}, [setCb, model.bookingNr, setAzeText])

	return (
		<div className={'CustomFieldDqLabelComponent'} css={cssCFSlct}>
			<SlctLabelOnly
				disabled={disabled}
				placeholderHTML={placeholderHTML}
				options={options}
				byValueCache={byValueCache}
				loading={loading}
				value={!modelValue && modelValue !== 0 ? null : modelValue}
				onChange={onChange}
				onChangeState={onChangeState}
				filterOptions={isDqSearchable(cfDef.dqKey) ? undefined : filterOptionsSlctNoValue}
				memo={memoParams}
				menuWidth={menuWidth}
				align={getCFAttrTextAlign(cfDef)}
			/>
		</div>
	)
})